export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

let loadPromise = null;

export function loadGoogleMaps() {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    if (window.google && window.google.maps) return resolve(window.google.maps);

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google.maps);
    document.head.appendChild(script);
  });

  return loadPromise;
}

export function geocodeLatLng(lat, lng) {
  return fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
  ).then(res => res.json());
}

export const GoogleMapsPlugin = {
  install(app) {
    app.config.globalProperties.$loadGoogleMaps = loadGoogleMaps;
    app.config.globalProperties.$geocodeLatLng  = geocodeLatLng;
  },
};